(() => {
  const controllers = new Map();
  const mobileQuery = window.matchMedia('(max-width: 989px)');

  function init(root) {
    if (!root || controllers.has(root)) return;
    const stage = root.querySelector('[data-fp-stage]');
    const frames = Array.from(root.querySelectorAll('.fp-main__frame[data-media-id]'));
    const thumbs = Array.from(root.querySelectorAll('[data-fp-thumb]'));
    const thumbsViewport = root.querySelector('[data-fp-thumbs]');
    if (!stage || frames.length < 2) return;

    let frame = 0;
    let activeIndex = Math.max(0, frames.findIndex((item) => item.classList.contains('is-active')));

    const centerThumb = (index, behavior = 'smooth') => {
      const thumb = thumbs[index];
      if (!thumb || !thumbsViewport) return;
      const viewportRect = thumbsViewport.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();
      const delta = thumbRect.left + thumbRect.width / 2 - viewportRect.left - viewportRect.width / 2;
      thumbsViewport.scrollBy({ left: delta, behavior });
    };

    const setActive = (index, center = true) => {
      if (index < 0 || index >= frames.length) return;
      activeIndex = index;
      frames.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
      thumbs.forEach((item) => {
        const isActive = item.dataset.fpThumb === frames[index].dataset.mediaId;
        item.classList.toggle('is-active', isActive);
        if (isActive) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
      if (center) centerThumb(index);
    };

    const visibleIndex = () => {
      const stageRect = stage.getBoundingClientRect();
      const stageCenter = stageRect.left + stageRect.width / 2;
      let nearest = activeIndex;
      let distance = Infinity;
      frames.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const nextDistance = Math.abs(rect.left + rect.width / 2 - stageCenter);
        if (nextDistance < distance) {
          distance = nextDistance;
          nearest = index;
        }
      });
      return nearest;
    };

    const onScroll = () => {
      if (!mobileQuery.matches) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setActive(visibleIndex(), false));
    };

    const scrollToIndex = (index, behavior = 'smooth') => {
      const nextIndex = (index + frames.length) % frames.length;
      const item = frames[nextIndex];
      item.scrollIntoView({ behavior, block: 'nearest', inline: 'start' });
      setActive(nextIndex);
    };

    const stopLegacySwipe = (event) => {
      if (mobileQuery.matches) event.stopPropagation();
    };

    const onSelect = (event) => {
      if (!mobileQuery.matches) return;
      const mediaId = String(event.detail?.mediaId || '');
      const index = frames.findIndex((item) => item.dataset.mediaId === mediaId);
      if (index >= 0) scrollToIndex(index, event.detail?.behavior || 'smooth');
    };

    const onClick = (event) => {
      if (!mobileQuery.matches) return;
      const thumb = event.target.closest('[data-fp-thumb]');
      const previous = event.target.closest('[data-fp-prev]');
      const next = event.target.closest('[data-fp-next]');
      if (!thumb && !previous && !next) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (thumb) {
        scrollToIndex(frames.findIndex((item) => item.dataset.mediaId === thumb.dataset.fpThumb));
      } else {
        scrollToIndex(activeIndex + (next ? 1 : -1));
      }
    };

    stage.addEventListener('scroll', onScroll, { passive: true });
    stage.addEventListener('pointerdown', stopLegacySwipe, true);
    stage.addEventListener('pointerup', stopLegacySwipe, true);
    stage.addEventListener('pointercancel', stopLegacySwipe, true);
    root.addEventListener('click', onClick, true);
    root.addEventListener('fp:gallery-select', onSelect);

    const onResize = () => {
      if (mobileQuery.matches) requestAnimationFrame(() => scrollToIndex(activeIndex, 'auto'));
    };
    window.addEventListener('resize', onResize, { passive: true });
    root.dataset.fpGalleryV2 = 'ready';
    setActive(activeIndex, false);

    controllers.set(root, () => {
      cancelAnimationFrame(frame);
      stage.removeEventListener('scroll', onScroll);
      stage.removeEventListener('pointerdown', stopLegacySwipe, true);
      stage.removeEventListener('pointerup', stopLegacySwipe, true);
      stage.removeEventListener('pointercancel', stopLegacySwipe, true);
      root.removeEventListener('click', onClick, true);
      root.removeEventListener('fp:gallery-select', onSelect);
      window.removeEventListener('resize', onResize);
      delete root.dataset.fpGalleryV2;
      controllers.delete(root);
    });
  }

  function initWithin(scope = document) {
    if (scope.matches?.('[data-fp-main]')) init(scope);
    scope.querySelectorAll?.('[data-fp-main]').forEach(init);
  }

  initWithin();
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:block:select', (event) => initWithin(event.target.closest?.('[data-fp-main]') || event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.('[data-fp-main]') ? event.target : event.target.querySelector?.('[data-fp-main]');
    controllers.get(root)?.();
  });
})();
